import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import { ArrowForwardIcon } from "@chakra-ui/icons";

// Pill colour per qset status, so "Continue" stands out from finished sets.
const STATUS_PILL = {
  Continue: "qset-pill--continue",
  "Try Now": "qset-pill--start",
  "View Responses": "qset-pill--review",
};

// The status action ("Try Now" / "Continue" / "View Responses") plus "Try Again" for finished sets.
// Styles live in App.scss under .qset-pill.
export const QSetActions = ({ status, onOpen, onTryAgain }) => (
  <Flex gap="2" justifyContent="flex-end">
    <Box
      as="button"
      type="button"
      className={`qset-pill ${STATUS_PILL[status] || ""}`}
      onClick={onOpen}
    >
      {status} <ArrowForwardIcon />
    </Box>
    {status === "View Responses" && (
      <Box
        as="button"
        type="button"
        className="qset-pill qset-pill--outline"
        onClick={onTryAgain}
      >
        Try Again
      </Box>
    )}
  </Flex>
);

// The empty-cell placeholder used across qset tables.
export const EmptyCell = () => <span className="qset-table__empty">—</span>;
